var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-coupon"},[_c('p',{staticClass:"shop-coupon__title"},[_vm._v("店铺优惠券")]),_c('p',{staticClass:"shop-coupon__subtitle"},[_vm._v(" 此模块无须预览，提供占位即可。 ")])])
}]

export { render, staticRenderFns }